
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlOe as ObiOwnShipControlOeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-oe.js';
 
 
 

 
 export const ObiOwnShipControlOe = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-oe',
   elementClass: ObiOwnShipControlOeElement,
   events: {
     
   }
  });
 
 